<template>
  <div class="EnrolledDetail">
    <Header msg="学员详情" />

    <template v-if="detail.id">
      <!-- 身份卡 -->
      <div class="card profile">
        <div class="flex flex-a-i-center">
          <!-- 没头像时用姓氏文字头像：默认图是带水印的 App logo，不能用 -->
          <img v-if="detail.avatar_url" v-lazy="{ src: detail.avatar_url, loading: require('@/assets/loading.gif'), error: require('@/assets/error.jpg') }" class="avatar" />
          <div v-else class="avatar avatar-initial">{{ initial }}</div>
          <div class="profile-info">
            <p class="p-name">{{ detail.show_name || detail.true_name || '-' }}</p>
            <p class="p-mobile">
              <a :href="'tel:' + detail.binding">{{ formatMobile(detail.binding) }}</a>
            </p>
          </div>
          <span class="tag-paid">已缴费</span>
        </div>
      </div>

      <!-- 报名信息 -->
      <div class="card">
        <p class="card-title">报名信息</p>
        <div class="kv">
          <span class="k">付款时间</span>
          <span class="v">{{ detail.pay_time_text || '-' }}</span>
        </div>
        <div class="kv">
          <span class="k">订单编号</span>
          <span class="v">{{ detail.order_no || '-' }}</span>
        </div>
        <div class="kv">
          <span class="k">推荐人</span>
          <span class="v">{{ detail.inviter_name || '-' }}</span>
        </div>
        <div class="kv">
          <span class="k">报考志愿</span>
          <span class="v">{{ detail.first_name || '-' }}</span>
        </div>
        <div class="kv">
          <span class="k">层次专业</span>
          <span class="v">【{{ detail.second_name || '-' }}】{{ detail.goods_name || '' }}</span>
        </div>
        <div class="kv">
          <span class="k">服务校区</span>
          <span class="v">{{ detail.campus || '-' }}</span>
        </div>
        <div class="kv" v-if="detail.clue || detail.clueType">
          <span class="k">线索来源</span>
          <span class="v">{{ detail.clue || '-' }} {{ detail.clueType || '' }}</span>
        </div>
      </div>

      <!-- 学员资料 -->
      <div class="card">
        <p class="card-title">学员资料</p>
        <div class="kv">
          <span class="k">证件号码</span>
          <span class="v v-idcard" @click="showFullIdcard = !showFullIdcard">
            {{ showFullIdcard ? detail.idcard || '-' : maskIdcard(detail.idcard) }}
            <i class="eye">{{ showFullIdcard ? '隐藏' : '查看' }}</i>
          </span>
        </div>
        <div class="kv">
          <span class="k">紧急联系人</span>
          <span class="v">{{ detail.crash_linkman || detail.critical_true_name || '-' }}</span>
        </div>
        <div class="kv">
          <span class="k">联系人手机</span>
          <span class="v">
            <a :href="'tel:' + (detail.crash_mobile || detail.critical_mobile_phone)">
              {{ detail.crash_mobile || detail.critical_mobile_phone || '-' }}
            </a>
          </span>
        </div>
        <div class="kv">
          <span class="k">工作单位</span>
          <span class="v">{{ detail.unit || '-' }}</span>
        </div>
        <div class="kv">
          <span class="k">所在地区</span>
          <span class="v">{{ detail.county || '-' }}</span>
        </div>
        <div class="kv" v-if="detail.address">
          <span class="k">详细地址</span>
          <span class="v">{{ detail.address }}</span>
        </div>
        <div class="kv" v-if="detail.express">
          <span class="k">物流公司</span>
          <span class="v">{{ detail.express }}</span>
        </div>
        <div class="kv" v-if="detail.express_no">
          <span class="k">物流单号</span>
          <span class="v">{{ detail.express_no }}</span>
        </div>
      </div>

      <!-- 操作 -->
      <div class="card ops">
        <div class="op-btn op-btn-ghost" @click="toSend(detail)">补充信息</div>
        <div class="op-btn op-btn-main" @click="callPhone">拨打电话</div>
      </div>
      <div class="card ops" v-if="detail.show == 1 && detail.commission != 3000.0">
        <div class="op-btn op-btn-ghost" @click="topage(detail)">查看订单</div>
        <div class="op-btn op-btn-warn" @click="showInvi(detail, true)">修改推荐人</div>
      </div>
    </template>

    <div class="empty flex flex-j-c-center flex-a-i-center" v-else>
      <img src="@/assets/null.png" />
      <p>暂无该学员信息</p>
    </div>

    <!-- 补充信息 -->
    <div class="mask mask-supplement" v-show="showMask" @click.self="mask(false)">
      <div class="sup-box">
        <div class="sup-head">
          <p class="sup-title">补充学员信息</p>
          <i class="sup-close" @click="mask(false)"></i>
        </div>

        <div class="sup-body">
          <p class="sup-sec">基本信息</p>
          <div class="sup-row">
            <span class="sup-label">姓名</span>
            <input type="text" class="sup-input" placeholder="请输入姓名" v-model.trim="setData.true_name" />
          </div>
          <div class="sup-row">
            <span class="sup-label">联系电话</span>
            <input type="tel" class="sup-input" placeholder="请输入联系电话" v-model.trim="setData.binding"
              oninput="if(value.length > 11)value = value.slice(0, 11)" />
          </div>
          <div class="sup-row">
            <span class="sup-label">证件号</span>
            <input type="text" class="sup-input" placeholder="请输入证件号" v-model.trim="setData.idcard"
              oninput="if(value.length > 18)value = value.slice(0, 18)" />
          </div>

          <p class="sup-sec">报考意向</p>
          <div class="sup-row" @click="showPopup('college')">
            <span class="sup-label">院校</span>
            <div class="sup-field">
              <span class="sup-value" :class="{ 'is-empty': !college.name }">{{ college.name || '请选择' }}</span>
              <i class="sup-arrow"></i>
            </div>
          </div>
          <!-- 已缴费订单：层次决定学费档位与提成，不允许再改；专业仍可重选 -->
          <div class="sup-row" :class="{ 'sup-row-locked': isPaid }" @click="showPopup('arrangement')">
            <span class="sup-label">层次</span>
            <div class="sup-field">
              <span class="sup-value" :class="{ 'is-empty': !arrangement.name }">{{ arrangement.name || '请选择' }}</span>
              <i class="sup-arrow" v-if="!isPaid"></i>
              <span class="sup-locked" v-else>不可修改</span>
            </div>
          </div>
          <div class="sup-row" @click="showPopup('major')">
            <span class="sup-label">专业</span>
            <div class="sup-field">
              <span class="sup-value" :class="{ 'is-empty': !major.name }">{{ major.name || '请选择' }}</span>
              <i class="sup-arrow"></i>
            </div>
          </div>
          <div class="sup-row" @click="showPopup('servicCampus')">
            <span class="sup-label">服务校区</span>
            <div class="sup-field">
              <span class="sup-value" :class="{ 'is-empty': !servicCampus.name }">{{ servicCampus.name || '请选择' }}</span>
              <i class="sup-arrow"></i>
            </div>
          </div>

          <p class="sup-sec">住址与工作</p>
          <div class="sup-row sup-row-top">
            <span class="sup-label">现住址</span>
            <div class="sup-field sup-field-block">
              <div class="sup-region">
                <v-region-selects @change="regionChange" :town="true" />
              </div>
              <p class="sup-region-text" v-if="county">{{ county }}</p>
            </div>
          </div>
          <div class="sup-row">
            <span class="sup-label">工作单位</span>
            <input type="text" class="sup-input" placeholder="请输入工作单位" v-model.trim="setData.unit" />
          </div>

          <p class="sup-sec">紧急联系人</p>
          <div class="sup-row">
            <span class="sup-label">联系人</span>
            <input type="text" class="sup-input" placeholder="请输入联系人姓名" v-model.trim="setData.crash_linkman" />
          </div>
          <div class="sup-row">
            <span class="sup-label">联系人手机</span>
            <input type="tel" class="sup-input" placeholder="请输入联系人手机号" v-model.trim="setData.crash_mobile"
              oninput="if(value.length > 11)value = value.slice(0, 11)" />
          </div>

          <p class="sup-sec">来源与物流</p>
          <div class="sup-row">
            <span class="sup-label">线索来源</span>
            <div class="sup-field sup-field-split">
              <div class="sup-pick" @click="showPopup('clue')">
                <span class="sup-value" :class="{ 'is-empty': !setData.clue }">{{ setData.clue || '来源' }}</span>
                <i class="sup-arrow"></i>
              </div>
              <div class="sup-pick" @click="showPopup('clueType')">
                <span class="sup-value" :class="{ 'is-empty': !setData.clueType }">{{ setData.clueType || '渠道' }}</span>
                <i class="sup-arrow"></i>
              </div>
            </div>
          </div>
          <div class="sup-row" @click="showPopup('ex')">
            <span class="sup-label">物流公司</span>
            <div class="sup-field">
              <span class="sup-value" :class="{ 'is-empty': setData.express === '请选择' || !setData.express }">{{
                setData.express === '请选择' ? '请选择' : setData.express }}</span>
              <i class="sup-arrow"></i>
            </div>
          </div>
          <div class="sup-row" v-show="setData.express !== '校区自取'">
            <span class="sup-label">物流单号</span>
            <input type="text" class="sup-input" placeholder="请输入物流单号" v-model.trim="setData.express_no" />
          </div>
        </div>

        <div class="sup-foot">
          <div class="sup-btn sup-btn-ghost" @click="mask(false)">取消</div>
          <div class="sup-btn sup-btn-main" @click="saveExpress">保存</div>
        </div>
      </div>
    </div>

    <!-- 修改推荐人 -->
    <div class="mask" v-show="showEdit">
      <div class="express-box">
        <div class="upload-box flex flex-j-c-sb">
          <div class="change-box" style="margin-bottom: 0.2rem">
            <img :src="setInviterChange.studentImg" class="avatar_img" />
            <p style="font-size: 0.14rem; color: #333333">{{ setInviterChange.studentName }}</p>
          </div>
          <div class="change-box" style="margin-bottom: 0.2rem">
            <img src="@/assets/change.png" style="width: 0.32rem; height: 0.32rem; padding-top: 0.16rem" />
            <p style="font-size: 0.13rem; color: rgb(250, 191, 1)">修改推荐人为</p>
          </div>
          <div class="change-box" style="margin-bottom: 0.2rem">
            <img :src="setInviterChange.inviterImg" class="avatar_img" />
            <p style="font-size: 0.14rem; color: #333333">{{ setInviterChange.inviterName }}</p>
          </div>
        </div>

        <div class="upload-box flex">
          <span>上传相关证明资料：</span>
        </div>
        <div class="upload-box flex flex-j-c-sb">
          <div class="upload-item">
            <a href="javascript:;" class="file">
              <img :src="testImg[0]" :class="testjudge[0] ? 'img-active' : ''" />
              <input type="file" id="ida" @change="handleFiles(0, 'myFiles0')" ref="myFiles0" />
            </a>
          </div>
          <div class="upload-item">
            <a href="javascript:;" class="file">
              <img :src="testImg[1]" :class="testjudge[1] ? 'img-active' : ''" />
              <input type="file" id="idb" @change="handleFiles(1, 'myFiles1')" ref="myFiles1" />
            </a>
          </div>
          <div class="upload-item">
            <a href="javascript:;" class="file">
              <img :src="testImg[2]" :class="testjudge[2] ? 'img-active' : ''" />
              <input type="file" id="idc" @change="handleFiles(2, 'myFiles2')" ref="myFiles2" />
            </a>
          </div>
        </div>

        <div class="upload-box flex">
          <span>是否已线下给介绍费：</span>
        </div>
        <div class="upload-box flex flex-j-c-sb">
          <div class="upload-item" style="width: 35%">
            <input type="radio" name="jsf" id="jsf1" value="1" style="padding-right: 1rem" @click="jsfConfirm(1)" />是&nbsp;&nbsp;&nbsp;
            <input type="radio" name="jsf" id="jsf2" value="2" @click="jsfConfirm(2)" />否
          </div>
        </div>

        <van-button type="default" class="express-box-btn" @click.native="saveInviterChang">确定</van-button>
        <img src="@/assets/home/Receive_icon_close@3x.png" class="box-close" @click="maskEdit(false)" />
      </div>
    </div>

    <!-- 选择推荐人 -->
    <div class="mask" v-show="isShowInviter" style="background: rgba(0, 0, 0, 0.7)">
      <img src="@/assets/home/Receive_icon_close@3x.png" class="mask-close" @click="showInvi(false, false)" />
      <div class="seach-box">
        <van-search v-model.trim="inviterkw" placeholder="请输入姓名" show-action shape="round" @search="onSearch"
          style="height: 0.5rem">
          <div slot="action" @click="onSearch" style="color: #fabf01">搜索</div>
        </van-search>
        <div class="per-line flex flex-j-c-sb" v-for="(e, i) in inviterArr" :key="`${i}one`">
          <div class="flex flex-a-i-center">
            <img :src="e.avatar_url || require('@/assets/teamAvatar.png')" class="item-avatar" />
            <div class="item-box flex flex-a-i-center flex-j-c-sb">
              <p class="item-name">{{ e.true_name || e.nickname }}</p>
            </div>
          </div>
          <div class="flex flex-a-i-center" @click="toEdit(e)">
            <p class="item-text">选择</p>
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom" class="mint-popup">
      <mt-picker :slots="slots" :itemHeight="50" :valueKey="Indexes" @change="onValuesChange" showToolbar ref="picker">
        <mt-header :title.sync="popupName">
          <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
          <mt-button slot="right" @click="handleConfirm">确定</mt-button>
        </mt-header>
      </mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import {
  teacherForder,
  teacherSend,
  searchInviter,
  uploadImg,
  postInviter,
  previewSubmit,
  modityLink,
  cityLink,
  campusLink,
  getOrigin,
} from '@/api'
import { Indicator, Toast } from 'mint-ui'
import expressData from '@/js/express.json'

export default {
  name: 'EnrolledDetail',
  components: { Header },
  data() {
    return {
      detail: {}, // 学员订单详情
      showFullIdcard: false, // 证件号是否完整展示
      oid: '', // 当前操作的订单 id

      popupVisible: false,
      popupType: '',
      popupName: '',
      Indexes: 'name',
      slots: [{ values: [] }],
      pageData: { list: [], fans: [], enroll: [] },
      college: {}, // 院校
      major: {}, // 专业
      servicCampus: {}, // 服务校区
      servicCampusArr: [],
      arrangement: {}, // 层次
      OriginInfoList: [],
      typeInfoList: [],
      clueData: [
        { id: 1, name: '线上' },
        { id: 2, name: '线下' },
      ],
      city: [{ id: 1941 }, { id: 1942 }],
      cityData: '',
      county: '',
      showMask: false,
      showEdit: false,
      isShowInviter: false,
      inviterkw: '',
      inviterArr: [],
      setInviterChange: {},
      testjudge: [false, false, false, false],
      testImg: [
        require('@/assets/jia.png'),
        require('@/assets/jia.png'),
        require('@/assets/jia.png'),
        require('@/assets/jia.png'),
      ],
      setData: {
        true_name: '',
        express: '请选择',
        express_no: '',
        binding: '',
        idcard: '',
        unit: '',
        clue: '',
        clueType: '',
        crash_mobile: '',
        crash_linkman: '',
        goods_name: '',
      },
    }
  },
  created() {
    this.getDetail()
    this.getOriginInfo()
    this.getPreView()
    this.getCity()
    this.getCampus()
  },
  computed: {
    // 无头像素材时的占位文字，取姓名首字
    initial() {
      const n = this.detail.show_name || this.detail.true_name || ''
      return n.trim().charAt(0)
    },
    // 已缴费订单的层次是只读的
    isPaid() {
      return Number(this.detail.is_pay) === 1
    },
  },
  watch: {
    $route(a) {
      this.getDetail()
    },
  },
  methods: {
    // 手机号按 3-4-4 分组显示，与设计稿一致
    formatMobile(m) {
      if (!m) return '-'
      const s = String(m).replace(/\D/g, '')
      return s.length === 11 ? `${s.slice(0, 3)} ${s.slice(3, 7)} ${s.slice(7)}` : m
    },
    // 单条详情：按 order_id 拉取，服务端仍会做招生归属校验，看不到别人的学员
    getDetail() {
      const id = this.$route.query.id
      if (!id) {
        Toast({ message: '缺少订单参数', className: 'iconfont icon-close' })
        return false
      }
      Indicator.open()
      teacherForder({ page: 1, limit: 1, type: 2, order_id: Number(id) })
        .then((res) => {
          Indicator.close()
          if (res.code === 0 && res.data && res.data.length) {
            this.detail = res.data[0]
          } else {
            Toast({ message: '未找到该学员', className: 'iconfont icon-close' })
            setTimeout(() => this.$router.go(-1), 1200)
          }
        })
        .catch(() => {
          Indicator.close()
          Toast({ message: '加载失败，请稍后重试', className: 'iconfont icon-close' })
        })
    },
    // 证件号脱敏：保留前 6 后 4
    maskIdcard(v) {
      const s = String(v || '')
      if (s.length < 11) return s || '-'
      return `${s.slice(0, 6)}${'*'.repeat(s.length - 10)}${s.slice(-4)}`
    },
    callPhone() {
      if (!this.detail.binding) {
        Toast({ message: '该学员未留手机号', className: 'iconfont icon-close' })
        return false
      }
      window.location.href = `tel:${this.detail.binding}`
    },
    topage(e) {
      this.$router.push({ path: `/Order?tId=${e.user_id}` })
    },
    getOriginInfo() {
      getOrigin().then((res) => {
        this.OriginInfoList = res.data || []
      })
    },
    // 院校/层次数据（补充信息弹层的选择项）
    getPreView() {
      previewSubmit().then((res) => {
        if (res.code === 0) {
          this.pageData = res.data
          if (this.pageData.list && this.pageData.list.length !== 0) {
            let colObj = {}
            this.pageData.list.map((item, index) => {
              if (item.id == 68) {
                this.college = item
                colObj.item = item
                colObj.index = index
              }
            })
            if (colObj.item) {
              this.pageData.list.splice(colObj.index, 1)
              this.pageData.list.push(colObj.item)
            }
          }
        }
      })
    },
    getCity() {
      cityLink().then((res) => {
        this.cityData = res.data
      })
    },
    getCampus(e = this.city[1].id) {
      campusLink({ city_id: e }).then((res) => {
        if (res.code === 0) {
          this.servicCampusArr = res.data
        } else {
          this.servicCampus = { name: '暂无' }
        }
      })
    },
    getModity(e) {
      let params = {
        first_cat_id: this.college.id,
        second_cat_id: this.arrangement.id,
      }
      modityLink(params).then((res) => {
        if (res.code === 0) {
          if (e === 1) {
            this.major = res.data[0]
          } else {
            if (this.slots[0].values !== res.data) {
              this.slots = [{ flex: 1, values: res.data, className: 'slot1', textAlign: 'center' }]
              this.popupType = 'major'
              this.popupName = '选择专业'
              this.Indexes = 'name'
            }
            this.popupVisible = true
          }
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    regionChange(data) {
      let arr = []
      if (data.province != null) arr.push(data.province.value)
      if (data.city != null) arr.push(data.city.value)
      if (data.area != null) arr.push(data.area.value)
      if (data.town != null) arr.push(data.town.value)
      this.county = arr.join('-')
    },
    // 打开补充信息弹层
    toSend(e) {
      this.oid = e.id
      this.setData.true_name = e.true_name || ''
      this.setData.binding = e.binding || ''
      this.setData.idcard = e.idcard || ''
      this.setData.unit = e.unit || ''
      this.setData.crash_mobile = e.crash_mobile || ''
      this.setData.crash_linkman = e.crash_linkman || ''
      this.setData.clue = e.clue || ''
      this.setData.clueType = e.clueType || ''
      this.setData.express = e.express || '请选择'
      this.setData.express_no = e.express_no || ''
      this.setData.goods_name = e.goods_name || ''
      this.county = e.county || ''
      this.servicCampus = { name: e.campus || '' }
      // goods_id 一起带上：不动专业时会原样回传，后端据此判断「本次没改专业」
      this.major = { id: e.goods_id || '', name: e.goods_name || '' }
      // 按名字把院校/层次的完整对象（含 id）还原出来。
      // 少了 id，层次一旦锁死就再也进不去「专业」选择器（它依赖 arrangement.id 去拉专业列表）
      const college = (this.pageData.list || []).find((item) => item.name === e.first_name)
      if (college) {
        this.college = college
        const arrangement = (college.son || []).find((item) => item.name === e.second_name)
        this.arrangement = arrangement || { name: e.second_name || '' }
      } else {
        this.college = { name: e.first_name || '' }
        this.arrangement = { name: e.second_name || '' }
      }
      this.mask(true)
    },
    mask(e) {
      this.showMask = e
    },
    saveExpress() {
      if (!this._tools.checkPhone(String(this.setData.binding))) {
        Toast({ message: '请输入正确的手机号码', className: 'iconfont icon-close', duration: 1500 })
        return false
      }
      this.saveMsg({
        order_id: this.oid,
        binding: this.setData.binding,
        idcard: this.setData.idcard,
        unit: this.setData.unit,
        true_name: this.setData.true_name,
        first_name: this.college.name || '',
        goods_id: this.major.id || '',
        goods_name: this.setData.goods_name,
        county: this.county,
        crash_mobile: this.setData.crash_mobile,
        crash_linkman: this.setData.crash_linkman,
        second_name: this.arrangement.name,
        goods_name: this.setData.goods_name,
        clueType: this.setData.clueType,
        clue: this.setData.clue,
        campus: this.servicCampus.name,
        express: this.setData.express,
        express_no: this.setData.express === '校区自取' ? '' : this.setData.express_no,
      })
    },
    // 保存信息
    saveMsg(data) {
      teacherSend(data).then((res) => {
        if (res.code === 0) {
          Toast({ message: '信息已更新', className: 'iconfont icon-dui' })
          // 直接刷新本地详情对象，避免从详情页返回再进来才看到变化
          this.detail.true_name = data.true_name
          this.detail.show_name = data.true_name
          this.detail.binding = data.binding
          this.detail.idcard = data.idcard
          this.detail.unit = data.unit
          this.detail.first_name = data.first_name
          this.detail.crash_mobile = data.crash_mobile
          this.detail.crash_linkman = data.crash_linkman
          this.detail.second_name = data.second_name
          this.detail.goods_name = data.goods_name
          this.detail.county = data.county
          this.detail.campus = data.campus
          this.detail.clue = data.clue
          this.detail.clueType = data.clueType
          this.detail.express = data.express
          this.detail.express_no = data.express_no
          this.mask(false)
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    showPopup(str) {
      let judge = true
      switch (str) {
        case 'ex':
          this.slots = [{ flex: 1, values: expressData, className: 'slot1', textAlign: 'center' }]
          this.popupName = '选择快递'
          break
        case 'clue':
          this.slots = [{ flex: 1, values: this.clueData, className: 'slot1', textAlign: 'center' }]
          this.Indexes = 'name'
          this.popupName = '选择线索'
          break
        case 'clueType':
          this.slots = [{ flex: 1, values: this.typeInfoList, className: 'slot1', textAlign: 'center' }]
          this.Indexes = 'type'
          this.popupName = '选择渠道'
          break
        case 'college':
          this.slots = [{ flex: 1, values: this.pageData.list, className: 'slot1', textAlign: 'center' }]
          this.Indexes = 'name'
          this.popupName = '选择院校'
          break
        case 'arrangement': // 层次：挂在所选院校的 son 下，换院校要清掉，否则专业对不上
          // 已缴费订单的层次不可改（学费档位与提成都挂在这上面）
          if (this.isPaid) {
            Toast({ message: '该学员已缴费，层次不可修改', className: 'iconfont icon-close' })
            return false
          }
          if (!this.college.id) {
            Toast({ message: '请先选择院校', className: 'iconfont icon-close' })
            judge = false
          } else if (!this.college.son || this.college.son.length === 0) {
            Toast({ message: '该院校暂无层次可选', className: 'iconfont icon-close' })
            judge = false
          } else {
            this.slots = [{ flex: 1, values: this.college.son, className: 'slot1', textAlign: 'center' }]
            this.Indexes = 'name'
            this.popupName = '选择层次'
          }
          break
        case 'major':
          if (!this.arrangement.id) {
            Toast({ message: '请选择层次', className: 'iconfont icon-close' })
            judge = false
          } else {
            this.getModity(0)
            judge = false
          }
          break
        case 'servicCampus':
          this.slots = [{ flex: 1, values: this.servicCampusArr, className: 'slot1', textAlign: 'center' }]
          this.Indexes = 'name'
          this.popupName = '选择校区'
          break
        default:
          break
      }
      if (judge) {
        this.popupVisible = true
        this.popupType = str
      }
    },
    handleConfirm() {
      switch (this.popupType) {
        case 'ex':
          this.setData.express = this.$refs.picker.getValues()[0]
          if (this.setData.express === '校区自取') this.setData.express_no = ''
          break
        case 'clue':
          this.setData.clue = this.$refs.picker.getValues()[0].name
          this.typeInfoList = this.OriginInfoList.filter(
            (item) => item.origin == this.$refs.picker.getValues()[0].id
          )
          this.setData.clueType = ''
          break
        case 'clueType':
          this.setData.clueType = this.$refs.picker.getValues()[0].type
          break
        case 'college':
          this.college = this.$refs.picker.getValues()[0]
          // 换院校后原层次/专业不再属于它，一并清空
          this.arrangement = {}
          this.major = {}
          this.setData.goods_name = ''
          break
        case 'arrangement':
          this.arrangement = this.$refs.picker.getValues()[0]
          this.major = {}
          this.setData.goods_name = ''
          break
        case 'major':
          this.major = this.$refs.picker.getValues()[0]
          this.setData.goods_name = this.major.name
          break
        case 'servicCampus':
          this.servicCampus = this.$refs.picker.getValues()[0]
          break
        default:
          break
      }
      this.popupVisible = false
    },
    onValuesChange(picker, values) {},
    // 修改推荐人
    showInvi(e, i) {
      this.inviterArr = []
      this.isShowInviter = i
      if (e) {
        this.setInviterChange.orderId = e.id
        this.setInviterChange.studentId = e.user_id
        this.setInviterChange.studentName = e.true_name
        this.setInviterChange.studentImg = e.avatar_url
      } else {
        this.setInviterChange = {}
      }
    },
    onSearch() {
      searchInviter({ keyword: this.inviterkw }).then((res) => {
        if (res.code === 0) {
          this.inviterArr = res.data
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    toEdit(e) {
      this.maskEdit(true)
      this.isShowInviter = false
      if (e) {
        this.setInviterChange.inviterId = e.id
        this.setInviterChange.inviterName = e.true_name
        this.setInviterChange.inviterImg = e.avatar_url
      } else {
        this.setInviterChange = {}
      }
    },
    maskEdit(e) {
      this.showEdit = e
      if (!e) this.setInviterChange = {}
    },
    handleFiles(index, e) {
      if (this.$refs[e].files.length === 0) return false
      var windowURL = window.URL || window.webkitURL
      this.param = { name: this.$refs[e].files[0] }
      uploadImg(this.param).then((res) => {
        if (res.code === 0) {
          this.testjudge.splice(index, 1, true)
          this.testImg.splice(index, 1, windowURL.createObjectURL(this.$refs[e].files[0]))
          const key = ['imgOne', 'imgTwo', 'imgThree'][index]
          if (key) this.setInviterChange[key] = res.data.url
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    jsfConfirm(val) {
      this.setInviterChange.jsf = val
    },
    saveInviterChang() {
      postInviter(this.setInviterChange).then((res) => {
        if (res.code === 0) {
          Toast({ message: res.msg, className: 'iconfont icon-dui' })
          this.maskEdit(false)
          this.testjudge = [false, false, false, false]
          this.testImg = [
            require('@/assets/jia.png'),
            require('@/assets/jia.png'),
            require('@/assets/jia.png'),
            require('@/assets/jia.png'),
          ]
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.EnrolledDetail {
  position: relative;
  min-height: 100vh;
  background: #eee;
  padding: 0.44rem 0 0.2rem;

  .card {
    width: 3.43rem;
    margin: 0.08rem auto 0;
    padding: 0.1rem 0.14rem;
    background: #fff;
    border-radius: 0.05rem;

    .card-title {
      font-size: 0.13rem;
      color: #333;
      font-weight: 500;
      padding-bottom: 0.04rem;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 0.04rem;
    }
  }

  .kv {
    display: flex;
    align-items: flex-start;
    padding: 0.06rem 0;
    font-size: 0.125rem;
    line-height: 1.5;

    .k {
      flex: 0 0 0.8rem;
      color: #999;
    }

    .v {
      flex: 1;
      text-align: right;
      color: #333;
      word-break: break-all;

      a {
        color: #185fa5;
      }
    }

    .v-idcard {
      .eye {
        font-style: normal;
        font-size: 0.11rem;
        color: #ba7517;
        margin-left: 0.06rem;
      }
    }
  }

  .profile {
    .avatar {
      flex: 0 0 0.5rem;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      margin-right: 0.12rem;
      object-fit: cover;
    }

    // 无头像素材时用它占位：浅蓝底 + 姓氏首字，替代带水印的默认图
    .avatar-initial {
      background: #dbe6ff;
      color: #2c5bd0;
      font-size: 0.22rem;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
    }

    .profile-info {
      flex: 1;
      min-width: 0;

      .p-name {
        font-size: 0.16rem;
        color: #666;
        line-height: 1.25;
      }

      .p-mobile {
        font-size: 0.13rem;
        color: #999;
        margin-top: 0.02rem;
        line-height: 1.25;

        // 头部手机号按设计稿是常规信息色，不是链接蓝（学员资料卡里的联系人手机才是蓝色）
        a {
          color: #999;
        }
      }
    }

    .tag-paid {
      font-size: 0.11rem;
      color: #0f6e56;
      background: #e1f5ee;
      border-radius: 0.03rem;
      padding: 0.02rem 0.07rem;
      height: 0.2rem;
      line-height: 0.16rem;
    }
  }

  .ops {
    display: flex;
    padding: 0.12rem 0.14rem;

    .op-btn {
      flex: 1;
      height: 0.36rem;
      line-height: 0.36rem;
      text-align: center;
      border-radius: 0.18rem;
      font-size: 0.14rem;
      margin: 0 0.05rem;
    }

    .op-btn-ghost {
      border: 1px solid #ddd;
      color: #666;
    }

    .op-btn-main {
      background: linear-gradient(90deg, #fabf01, #fa9901);
      color: #ffffff;
    }

    .op-btn-warn {
      border: 1px solid #fabf01;
      color: #ba7517;
    }
  }

  .empty {
    flex-direction: column;
    padding: 1rem 0;
    color: #fabf01;

    img {
      width: 0.5rem;
      height: 0.5rem;
    }

    p {
      font-size: 0.13rem;
      color: #999;
      margin-top: 0.06rem;
    }
  }
}
// 补充信息弹层：整块定宽 + 头/尾固定 + 中间滚动，避免字段一多就顶出屏幕
.mask-supplement {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.16rem;

  .sup-box {
    width: 3.43rem;
    max-width: 100%;
    max-height: 86vh;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 0.06rem;
    overflow: hidden;
  }

  .sup-head {
    position: relative;
    flex: 0 0 auto;
    height: 0.46rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f2f3f5;

    .sup-title {
      font-size: 0.15rem;
      color: #333;
      font-weight: 500;
    }

    // 关闭按钮改到右上角卡片内，原来放在卡片底部外侧，像个含义不明的箭头
    .sup-close {
      position: absolute;
      top: 0.15rem;
      right: 0.14rem;
      width: 0.16rem;
      height: 0.16rem;

      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 1px;
        background: #c0c4cc;
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }
    }
  }

  .sup-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 0.14rem;

    .sup-sec {
      font-size: 0.12rem;
      color: #999;
      line-height: 0.16rem;
      padding: 0.12rem 0 0.02rem 0.07rem;
      position: relative;

      // 分组标题左侧的金色小竖条
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.145rem;
        width: 0.02rem;
        height: 0.11rem;
        border-radius: 0.01rem;
        background: #fabf01;
      }
    }

    .sup-row {
      display: flex;
      align-items: center;
      min-height: 0.44rem;
      padding: 0.05rem 0;
      border-bottom: 1px solid #f4f5f7;

      &:last-child {
        border-bottom: none;
      }
    }

    // 已缴费订单的层次：值置灰、去掉箭头换成「不可修改」，点了也不响应
    .sup-row-locked {
      .sup-value {
        color: #888;
      }

      .sup-locked {
        flex: 0 0 auto;
        font-size: 0.11rem;
        color: #bbb;
        margin-left: 0.06rem;
      }
    }

    // 内容区高于单行的字段（现住址），标签顶部对齐
    .sup-row-top {
      align-items: flex-start;

      .sup-label {
        line-height: 0.3rem;
      }
    }

    .sup-label {
      flex: 0 0 0.82rem;
      font-size: 0.13rem;
      color: #333;
      white-space: nowrap;
    }

    .sup-field {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .sup-field-block {
      display: block;
    }

    .sup-input {
      flex: 1;
      min-width: 0;
      width: 100%;
      height: 0.32rem;
      padding: 0 0.08rem;
      font-size: 0.13rem;
      color: #333;
      background: #f7f8fa;
      border: none;
      border-radius: 0.04rem;
      text-align: left;
      -webkit-appearance: none;
      appearance: none;

      &::placeholder {
        color: #bbb;
      }
    }

    .sup-value {
      font-size: 0.13rem;
      color: #333;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .sup-value.is-empty {
      color: #bbb;
    }

    // 右侧灰色箭头，提示这一行可以点
    .sup-arrow {
      flex: 0 0 auto;
      width: 0.065rem;
      height: 0.065rem;
      margin-left: 0.08rem;
      border-top: 1px solid #c8c9cc;
      border-right: 1px solid #c8c9cc;
      transform: rotate(45deg);
    }

    // 线索来源 + 渠道：两个窄选择器平分，替代原来 20%/50% 的混乱比例
    .sup-field-split {
      display: flex;

      .sup-pick {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 0.32rem;
        padding: 0 0.08rem;
        background: #f7f8fa;
        border-radius: 0.04rem;

        & + .sup-pick {
          margin-left: 0.08rem;
        }

        .sup-value {
          flex: 1;
        }
      }
    }

    // 四个级联选择器竖向铺满，横向并排挤不下
    .sup-region {
      padding: 0.03rem 0;

      /deep/ div.rg-select {
        display: block;
        width: 100%;
        margin: 0 0 0.05rem;

        &:last-child {
          margin-bottom: 0;
        }

        div.rg-select__el {
          border-color: #f0f1f3;
          background: #f7f8fa;
        }

        div.rg-select__el div.rg-select__content {
          width: 100%;
          padding: 0.06rem 0.24rem 0.06rem 0.08rem;
          font-size: 0.13rem;
          color: #333;
          box-sizing: border-box;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .sup-region-text {
      font-size: 0.12rem;
      color: #999;
      line-height: 1.5;
      padding: 0.04rem 0 0.02rem;
      word-break: break-all;
    }
  }

  .sup-foot {
    flex: 0 0 auto;
    display: flex;
    padding: 0.1rem 0.14rem 0.14rem;
    border-top: 1px solid #f2f3f5;

    .sup-btn {
      flex: 1;
      height: 0.38rem;
      line-height: 0.38rem;
      text-align: center;
      border-radius: 0.19rem;
      font-size: 0.14rem;
    }

    .sup-btn-ghost {
      border: 1px solid #ddd;
      color: #666;
      margin-right: 0.1rem;
    }

    .sup-btn-main {
      background: linear-gradient(90deg, #fabf01, #fa9901);
      color: #fff;
    }
  }
}

.mint-popup {
  width: 80%;
  height: auto;
  padding: 0.2rem 0.16rem;
  background: white;
  border-radius: 0.1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 78vh;
  overflow-y: scroll;

  .express-box-btn {
    width: 80%;
    margin: 0.2rem auto 0;
    border-radius: 0.2rem;
    height: 0.35rem;
    color: white;
    background: linear-gradient(90deg, #fabf01, #fa9901);
    line-height: 0.35rem;
  }

  .box-close {
    width: 0.25rem;
    height: 0.25rem;
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
.mint-popup {
  width: 100%;
  border-radius: 8px 8px 0 0;
}
.per-line {
  height: auto;
  line-height: 0.4rem;
  padding: 0.1rem 0.16rem;
  background: white;
}
.item-avatar {
  width: 0.56rem;
  height: 0.56rem;
  margin-right: 0.12rem;
  border-radius: 50%;
}
.item-name {
  font-size: 0.16rem;
  width: 100%;
  margin-bottom: 0.1rem;
}
.item-text {
  font-size: 0.14rem;
  color: white;
  width: 0.7rem;
  height: 0.24rem;
  line-height: 0.24rem;
  border-radius: 0.12rem;
  background: linear-gradient(90deg, #fabf01, #fa9901);
  text-align: center;
}
.seach-box {
  width: 90%;
  padding: 0.16rem;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 0.1rem;
  max-height: 55vh;
  overflow-y: scroll;
}
.mask-close {
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  top: 0.5rem;
  right: 5%;
}
.upload-box {
  padding: 0.1rem 0.2rem;
  background: white;

  .upload-item {
    width: 30%;

    p {
      font-size: 0.12rem;
      color: #999999;
    }
  }

  .file {
    position: relative;
    display: inline-block;
    background: #f7f7f7;
    border: 1px dashed #7d7d7d;
    border-radius: 4px;
    overflow: hidden;
    color: #1e88c7;
    width: 100%;
    height: 0.8rem;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0.28rem;
      height: 0.28rem;
    }

    .img-active {
      width: 100%;
      height: 100%;
    }
  }

  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
</style>
